import { render, staticRenderFns } from "./BlogSectionCategoriesStatic.vue?vue&type=template&id=570b7496&scoped=true&lang=pug&"
import script from "./BlogSectionCategoriesStatic.vue?vue&type=script&lang=js&"
export * from "./BlogSectionCategoriesStatic.vue?vue&type=script&lang=js&"
import style0 from "./BlogSectionCategoriesStatic.vue?vue&type=style&index=0&id=570b7496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b7496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570b7496')) {
      api.createRecord('570b7496', component.options)
    } else {
      api.reload('570b7496', component.options)
    }
    module.hot.accept("./BlogSectionCategoriesStatic.vue?vue&type=template&id=570b7496&scoped=true&lang=pug&", function () {
      api.rerender('570b7496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BlogSectionCategoriesStatic.vue"
export default component.exports